"use client";

import { motion } from "framer-motion";
import { CornerUpRight } from "lucide-react";

export function Banner({ page, heading, image }) {


  return (
    <>
      <div className="relative flex flex-col">
        <div className="w-full mx-auto z-10">
          <div className="relative before:absolute before:inset-0 before:bg-[#1c262ee7] before:opacity-75 w-full h-[400px]">
            <motion.img
              src={image}
              alt={"About-us"}
              className="size-full object-cover"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            />
            <motion.div
              className="text-left text-white absolute top-1/3 left-1/4 sm:left-1/3 p-4 sm:p-8 max-w-2xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
            >
              <h1 className="text-[30px] md:text-5xl lg:text-6xl font-medium mb-4 leading-none">
                {heading}
              </h1>
            </motion.div>
          </div>
        </div>
        <div className="absolute inset-y-0 left-0 bg-[#03345c] w-12 z-30 h-full">
          <p className="text-white font-Satoshi text-base font-semibold tracking-[3px] rotate-180 uppercase px-4 py-8 writing-mode-tb-rl flex justify-start h-full items-center w-full">
            Contact US
          </p>
        </div>
      </div>
      <motion.div
        className="bg-[#dededead]"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
      >
        <div className="pr-3 py-3 pl-24 md:pr-4 text-left text-black">
          <div className="flex items-center gap-3">
            <a
              href="/"
              className="flex items-center gap-1 text-sm md:text-base"
            >
              <span className="inline-block">Home</span>
              <span className="inline-block">
                <CornerUpRight className="size-4" />
              </span>{" "}
            </a>{" "}
            <span className="flex items-center gap-3 text-cyan-900 font-bold text-vase md:text-xl">
              {page}
            </span>
          </div>
        </div>
      </motion.div>
    </>
  );
}
